var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contentPageBreak"}},[_c('Page',{attrs:{"current":_vm.pageData.pageNow+1,"total":_vm.pageData.pageTotal,"page-size":_vm.pageData.pageSize},on:{"on-change":_vm.changePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }